import { render, staticRenderFns } from "./ScoopQuestionAnswer.vue?vue&type=template&id=5859a7c0&scoped=true&"
import script from "./ScoopQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./ScoopQuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ScoopQuestionAnswer.vue?vue&type=style&index=0&id=5859a7c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859a7c0",
  null
  
)

export default component.exports